import React, { useEffect, useState, useRef } from 'react';
import DataTable from "react-data-table-component";
import axios from 'axios';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import Navbar from '../NavBar/Navbar';
import MapDashboard from '../myproporties/MapDashboard';
import FadeLoader from "react-spinners/FadeLoader";
import { FcCancel } from "react-icons/fc";
import StatusDropdown from '../MyWorklist/StatusDropdown'
import { BiSortAlt2 } from "react-icons/bi";
import Popover from '@mui/material/Popover';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import { useUser } from "../utils/UserContext.jsx"; // Import the custom hook

const ViewPrakingLotInfo = (EmailId) => {
  const [anchorEl, setAnchorEl] = useState(null);  // State to track anchor element for the popup
  const [selectedRowData, setSelectedRowData] = useState(null);
  const hostPath = process.env.REACT_APP_API_BASE_URL;
  const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
  const [parkingLotBookingDetails, setParkingLotBookingDetails] = useState([]);
  const [filter, setFilter] = useState([]);
  const [search, setSearch] = useState("");
  const [, setPopupVisible] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [rowData, setRowData] = useState([]);
  const [areasmarked, setAreasmarked] = useState([]);
  const [isEdit, setEdit] = useState();
  const [parkinglotObj, setparkinglotObj] = useState();
  const [loader, setLoader] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(''); // This will store the selected status
  const [sortDirection, setSortDirection] = useState('asc'); // State for sorting direction
  const [editOption, setEditoption] = useState();
  const [addProperty, setAddproperty] = useState(false);
  const [mapVisibleChanges, setMapVisibleChanges] = useState(false);
  const { userDetails, employeeData } = useUser();
  const [userData] = useState(userDetails);
  const [defaultaddress, setDefaultaddress] = useState("");
  const [entityId, setEntityId] = useState(null);
  const [empRegistrationId, setEmpRegistrationId] = useState(null)
  const [isEmployee, setIsEmployee] = useState(false);

  const entityIdRef = useRef(null);
  const hasFetchedRef = useRef(false);


  const fetchParkinglotDetails = async () => {
    const id = entityIdRef.current;
    if (!id) return;

    setLoader(true);
    try {
      const body = isEmployee
        ? { EmpRegistrationID: id }
        : { EntityRegistrationID: id };

      const response = await fetch(
        `${hostPath}/api/ParkingLotBookingDetailsbyId`,
        {
          method: "POST",
          headers: {
            "x-functions-key": hostHeader,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      setParkingLotBookingDetails(data);
      setFilter(data);
    } catch (err) {
      console.error("Fetch failed:", err);
      setParkingLotBookingDetails([]);
      setFilter([]);
    } finally {
      setLoader(false);
    }
  };


  useEffect(() => {
    if (isEmployee && empRegistrationId) {
      entityIdRef.current = empRegistrationId;
    } else if (!isEmployee && entityId) {
      entityIdRef.current = entityId;
    }
  }, [isEmployee, entityId, empRegistrationId]);

  useEffect(() => {
    if (userDetails) {
      setEntityId(userDetails.entityRegistrationID);
      setIsEmployee(false);
    } else if (employeeData) {
      setIsEmployee(true);
      setEntityId(employeeData.entityRegistrationID);
      setEmpRegistrationId(employeeData.empRegistrationID);
    }
  }, [userDetails, employeeData]);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    if (!entityIdRef.current) return;

    hasFetchedRef.current = true;
    fetchParkinglotDetails();
  }, []);

  useEffect(() => {
    let result = parkingLotBookingDetails;

    if (search) {
      result = result.filter((item) =>
        (item.parkingLotAddress || "")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }
    setFilter(result);
  }, [search, parkingLotBookingDetails]);

  useEffect(() => {
    if (!entityIdRef.current) return;
    fetchParkinglotDetails();
  }, []); // 👈 EMPTY dependency (important)

  useEffect(() => {
    console.log("userDetails1111111111111", userDetails);

    if (userDetails) {
      setDefaultaddress(userDetails.enityMailingAdderess);
      setEntityId(userDetails.entityRegistrationID);
      setIsEmployee(false)
    } else if (employeeData) {
      setIsEmployee(true)
      setDefaultaddress(employeeData.enityMailingAdderess);
      setEntityId(employeeData.entityRegistrationID);
      setEmpRegistrationId(employeeData.empRegistrationID)

    }
  }, [userDetails, employeeData]);

  useEffect(() => {
    if (isEmployee && empRegistrationId) {
      fetchParkinglotDetails(empRegistrationId);
    } else if (!isEmployee && entityId) {
      fetchParkinglotDetails(entityId);
    }
  }, [isEmployee, entityId, empRegistrationId, hostPath]);

  useEffect(() => {
    let result = parkingLotBookingDetails;

    // Filter by search query
    if (search) {
      result = result.filter((item) => {
        return (item.parkingLotAddress || item.createdDate || item.nickName).toLowerCase().includes(search.toLowerCase());
      });
    }
    // Filter by selected status
    if (selectedStatus.length > 0) {
      result = result.filter((item) => selectedStatus.includes(item.status));
    }
    setFilter(result);
  }, [search, parkingLotBookingDetails, selectedStatus]);
  const handleDelete = (val, typeOfButton) => {
    let message;
    let message2;
    let status;
    if (typeOfButton === 'trash') {
      message = 'Are you sure you want to delete this property? This action is irreversible.';
      message2 = 'Once you proceed, you will not be able to undo this action. Please confirm if you wish to continue.'
      status = 'delete';
    } else if (typeOfButton === 'cancel') {
      message = 'Are you sure you want to mark this property as inactive?';
      message2 = 'You can make it active again in the future if you wish. Please confirm if you wish to continue.'
      status = 'Inactive'
    }
    else if (typeOfButton === 'active') {
      message = 'Are you sure you want to mark this property as active?';
      message2 = 'Please confirm if you wish to continue.'
      status = 'Submitted'
    }

    let data = { EmailId: val.emailId, Parking_Lot_ID: val.parking_Lot_ID, message, message2, status, val };
    setRowData(data);
    setOpen(true);
    setPopupVisible(false);
  };
  const handleConfirm = (text, status, val) => {

    if (text === 'confirm') {

      if (status === 'delete') {
        const requestOptions = {
          method: 'POST',
          headers: { "x-functions-key": hostHeader },
          body: JSON.stringify(rowData)
        };
        setLoader(true);

        axios.post(`${hostPath}/api/DeleteParkingLotDetailsByEmailId`, requestOptions.body, { headers: requestOptions.headers })
          .then(response => {
            if (response.data) {
              if (response.data.status) {
                const newdata = parkingLotBookingDetails.filter((item) => item.parking_Lot_ID !== rowData.Parking_Lot_ID);
                setParkingLotBookingDetails(newdata);
                setFilter(newdata);
                setOpen(false);
              }
              else {
                alert(response.data.responseMessage);
              }
            }
          })
          .catch(error => {
            console.error('Error:', error);
          })
          .finally(() => {
            setLoader(false);
          })
      }
      else if (status === 'Inactive' || status === 'Submitted') {
        let statusval = status;
        if (status === 'Submitted') {
          if (val?.verifyStatus === "Active" || val?.verifyStatus === "Rejected") {
            statusval = val?.verifyStatus
          }
        }
        const CoardinateDetails = val?.coardinateDetails;
        const Scheduleavailability = val?.scheduleavailability
        const parkinglot = {
          "EmailId": val.emailId,
          "EntityRegistrationID": val?.entityRegistrationID,
          "ParkingLotAddress": val?.parkingLotAddress,
          "Parking_Lot_ID": val?.parking_Lot_ID,
          "id": val?.id,
          "CreatedDate": val?.createdDate,
          "Status": statusval,
          "Comment": val?.comment,
          "StreetName": val?.streetName,
          "VerifyStatus": val?.verifyStatus,
          "BankDetailID": val?.bankDetailID,
          "Nickname": val?.nickName,
          CoardinateDetails,
          Scheduleavailability
        };
        axios.post(`${hostPath}/api/UpdateParkingLotDetails`, parkinglot, {
          headers: {
            "x-functions-key": hostHeader
          }
        })
          .then(response => {
            if (response.data) {
              fetchParkinglotDetails();
              setOpen(false);
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
      }
    }
    else if (text === 'cancel') {
      setOpen(false);
    }
  };

  const handleEdit = (e, val) => {
    setSelectedRowData(val);
    setAnchorEl(e.currentTarget);  // Set the clicked element as the anchor for the popup
  };

  const handleEdittomap = (val) => {
    console.log("valTest", val);

    setparkinglotObj(val);
    setDefaultaddress(val?.parkingLotAddress);

    /* ----------------------------------------------------
       🔹 BUILD GROUP → NORMALIZED SCHEDULE MAP
    ---------------------------------------------------- */
    const groupScheduleMap = {};

    (val?.groupSchedules || []).forEach((group) => {
      const groupName = group.groupName || "Default";

      groupScheduleMap[groupName] = (group.schedules || []).map((sch) => ({
        id: sch.id,
        title: sch.title,
        allDay: sch.allDay || false,
        recurrence: sch.recurrence,
        customRecurrenceCount: sch.customRecurrenceCount || 0,

        // ✅ Normalize dates (VERY IMPORTANT)
        start: sch.start ? new Date(sch.start) : null,
        end: sch.end ? new Date(sch.end) : null,
        endType: sch.endType,
        endDateOn: sch.endDateOn ? new Date(sch.endDateOn) : null,
        endAfter: sch.endAfter,

        // ✅ Inject groupName (missing earlier)
        groupName,

        isMaster: sch.isMaster ?? true,
        isActive: sch.isActive ?? true,
      }));
    });

    /* ----------------------------------------------------
       🔹 TRANSFORM PSLs + ATTACH GROUP SCHEDULES
    ---------------------------------------------------- */
    const transformedAreas = (val?.coardinateDetails || []).map((details) => {
      const groupName =
        Array.isArray(details?.groupName)
          ? details.groupName[0]
          : details?.groupName || "Default";

      return {
        Coordinates: {
          Title: details?.title || "PSL - Parking Space Location",
          Latitude: parseFloat(details?.latitude) || 0,
          Longitude: parseFloat(details?.longitude) || 0,
        },
        Name: details?.title || "PSL - Parking Space Location",
        id: parseInt(details?.id, 10) || Date.now(),
        VehicleSpotSize: details?.vechileSpotSize || "",
        pslName: details?.pslName || "",
        groupName,

        latandlong: `Latitude: ${parseFloat(details?.latitude) || 0} Longitude: ${parseFloat(details?.longitude) || 0}`,

        // ✅ FINAL: PSL gets schedules from its GROUP
        ScheduleAvailability: groupScheduleMap[groupName] || [],
      };
    });

    console.log("transformedAreasTest", transformedAreas);

    setAreasmarked(transformedAreas);
    setEdit(true);
    setPopupVisible(false);
  };

  const handleStatusChange = (selectedStatus) => {
    setSelectedStatus(selectedStatus);
  };
  const handleSort = (column) => {
    // Toggle the sorting direction
    const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    setSortDirection(newSortDirection);

    // Sort the data based on the 'createdDate' field
    const sortedData = [...filter].sort((a, b) => {
      const dateA = new Date(a[column]);
      const dateB = new Date(b[column]);

      if (newSortDirection === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });

    setFilter(sortedData);
  };
  const columns = [
    {
      name: "Nickname",
      selector: (row) => row.nickName,
    },
    {
      name: "Street Address",
      cell: (row) => (
        <div
          style={{ cursor: 'pointer' }}  // Style to indicate it's clickable
          onClick={(e) => handleEdittomap(row)} // Call function when clicked
        >
          {row.parkingLotAddress}
        </div>
      ),
    },
    {
      name: (
        <div style={{ whiteSpace: "normal", textAlign: "center" }}>
          Parking Spaces Selected
        </div>
      ),
      selector: (row) =>
        row?.coardinateDetails?.filter((coord) => coord.title === "PSL - Parking Space Location").length || 0,
      grow: 1,
      wrap: true,
      center: true,
      style: { justifyContent: "center", textAlign: "center" },
    },
    {
      name: (
        <div style={{ whiteSpace: "normal", textAlign: "center" }}>
          Created By
        </div>
      ),
      selector: (row) => row?.createdBy,
    },

    {
      name: (
        <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort('createdDate')}>
          Created Date <BiSortAlt2 style={{ marginLeft: '5px' }} />
        </div>
      ),
      selector: (row) => row.createdDate,
    },
    {
      name: (
        <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort("lastUpdatedDate")}>
          Last Updated <BiSortAlt2 style={{ marginLeft: '5px' }} />
        </div>
      ),
      selector: (row) => row.lastUpdatedDate,
    },
    {
      name: (
        <div style={{ display: 'flex', alignItems: 'start' }}>
          <StatusDropdown handleStatusChange={handleStatusChange} />
        </div>
      ),
      selector: (row) => row?.status,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '0px' }}>
          {row.status === 'Inactive' ? (
            <>
              {/* Show "Activate" icon for inactive status */}
              <FiEdit3 title="Activate" aria-label="Activate"
                style={{
                  width: "38px",
                  height: "25px",
                  padding: "2px 2px",
                  cursor: "pointer",
                  justifyContent: "center",
                  color: "green"
                }}
                onClick={() => handleDelete(row, 'active')}  // Change status to Active
              />
            </>
          ) : (
            <>
              {/* Show default edit and delete icons for active status */}
              <FiEdit3 title="Edit" aria-label="Edit"
                style={{
                  width: "38px",
                  height: "25px",
                  padding: "2px 2px",
                  cursor: "pointer",
                  justifyContent: "center",
                }}
                onClick={(e) => handleEdit(e, row)} />
              <FiTrash2 title="Delete" aria-label="Delete"
                style={{
                  width: "38px",
                  height: "25px",
                  padding: "2px 2px",
                  cursor: "pointer",
                  justifyContent: "center",
                }}
                onClick={() => handleDelete(row, 'trash')}  // Pass 'trash' as the type
              />
              <FcCancel
                title={row.status === 'Active' ? 'Inactive' : 'Disabled'}
                aria-label="Inactive"
                style={{
                  width: "38px",
                  height: "25px",
                  padding: "2px 2px",
                  cursor: row.status === 'Active' ? "pointer" : "not-allowed",
                  justifyContent: "center",
                  opacity: row.status === 'Active' ? 1 : 0.5, // visually show it's disabled
                }}
                onClick={row.status === 'Active' ? () => handleDelete(row, 'cancel') : null}
              />

            </>
          )}
        </div>
      ),
    },
  ];

  const handleClose = () => {
    setAnchorEl(null);  // Close the popup
  };

  const Isopen = Boolean(anchorEl);  // Boolean to check if the popup is open
  const id = Isopen ? 'edit-popover' : undefined;

  const handleOptionClick = (option) => {
    setEditoption(option);
    setAnchorEl(null);  // Close the popup after selecting an option
    handleEdittomap(selectedRowData);
  };
  const handleAddProperty = (val) => {
    setAddproperty(val);
    setEdit(val);
  }
  const handleMapVisibleChanges = (value) => {
    setMapVisibleChanges(value);
  };
  return (
    <div>
      {loader && (
        <div className="loader-overlay">
          <FadeLoader />
        </div>
      )}
      <Navbar userData={userData} mapvisible={mapVisibleChanges} setMapvisible={setMapVisibleChanges} />
      {!isEdit ? (

        <div>
          <div className='container-fluid p-0'>
            <div className="lotmanagement">
              <div className="row" style={{ textAlign: "left" }}>
                <div className="col-8">
                  <div className='viewHeader'>Registered Parking Lots</div>
                  <div className='listview'>View the list of parking lots registered</div>
                  {/* <div style={{ color: 'blue', cursor: 'pointer', marginBottom: '15px', fontSize: '16px' }} onClick={navigateToDashboard}>Sign up more parking lots</div> */}
                </div>
              </div>

              <div className="row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                {/* Left side: Total parking lots */}
                <div className="col-6 mb-2" style={{ textAlign: "left" }}>
                  Total parking lots: {parkingLotBookingDetails.length}
                </div>
                {/* Right side: Search input + Add button */}
                <div className="col-6 mb-2" style={{ textAlign: "right", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by address."
                    style={{ maxWidth: "300px" }}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button className="add-property-btn" onClick={() => handleAddProperty(true)}>
                    Add Property
                  </button>
                </div>
              </div>
              <React.Fragment>
                <DataTable
                  columns={columns}
                  data={filter.length ? filter : []}
                  pagination
                  highlightOnHover
                  fixedHeader
                  selectableRowsHighlight
                  persistTableHead
                  expandableRows
                  expandableRowsComponent={({ data }) => <ExpandedGroupsView data={data} />}
                  expandableIcon={{
                    collapsed: (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                      >
                        <ExpandMoreIcon style={{ fontSize: "20px", color: "#444" }} />
                      </div>
                    ),
                    expanded: (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                      >
                        <ExpandLessIcon style={{ fontSize: "20px", color: "#444" }} />
                      </div>
                    ),
                  }}


                  customStyles={{
                    table: {
                      style: {
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
                      },
                    },
                    headCells: {
                      style: {
                        backgroundColor: "#f8f8f8",
                        fontWeight: "700",
                        fontSize: "15px",
                        borderBottom: "2px solid #e0e0e0",
                      },
                    },
                    rows: {
                      style: {
                        backgroundColor: "#fff",
                        borderBottom: "1px solid #e0e0e0",
                        minHeight: "60px",
                        transition: "all 0.2s ease",
                      },
                      highlightOnHoverStyle: {
                        backgroundColor: "#fafafa",
                        borderBottomColor: "#ddd",
                        outline: "none",
                      },
                    },
                    cells: {
                      style: {
                        fontSize: "14px",
                        color: "#333",
                        padding: "10px 14px",
                        textAlign: "center",
                      },
                    },
                  }}
                  noDataComponent={<div style={{ padding: 20 }}>No records found</div>}
                />


              </React.Fragment>
            </div>
          </div>
          <Dialog
            classes={{ paper: 'custom-paper-class-delete' }}
            aria-labelledby="customized-dialog-title"
            dividers
            open={open}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <DialogTitle dividers sx={{ textAlign: 'start', color: "#000;", fontSize: "24px", fontWeight: "700", padding: "5px 24px " }} id="customized-dialog-title">
              {rowData?.message}  {/* Display different messages based on the button clicked */}
            </DialogTitle>
            <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000;" }}>
              <Typography gutterBottom>
                <span>{rowData?.message2}</span>
              </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'right' }}>
              <Button
                className='custom-button-cancel'
                onClick={() => handleConfirm('cancel')}
              >
                Cancel
              </Button>
              <Button
                className='custom-button-delete'
                onClick={() => handleConfirm('confirm', rowData?.status, rowData?.val)}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>

          <Popover
            id={id}
            open={Isopen}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',  // Popup will appear to the left of the clicked icon
              height: '500px',
              width: '500px'
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'right',  // Popup will align to the right side of the anchor element
            }}
          >
            <div style={{ padding: '10px' }}> {/* Additional padding for content */}
              <Button
                variant="text"
                onClick={() => handleOptionClick('parkingspaces')}
                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }}
              >
                Parking Spaces
              </Button>
              <Button
                variant="text"
                onClick={() => handleOptionClick('parkingschedule')}
                disabled={
                  (selectedRowData?.coardinateDetails?.filter(coord => coord.title === "PSL - Parking Space Location").length || 0) === 0
                }
                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }}
              >
                Parking Schedule
              </Button>
              <Button
                variant="text"
                onClick={() => handleOptionClick('bankdetails')}
                disabled={
                  (selectedRowData?.coardinateDetails?.filter(coord => coord.title === "PSL - Parking Space Location").length || 0) === 0
                }
                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }}
              >
                Bank Details
              </Button>
            </div>
          </Popover>


        </div>
      ) : (
        !addProperty ? (
          <div><MapDashboard isEdit={isEdit} areasMarked={areasmarked} defaultaddress={defaultaddress} userData={userDetails} entityId={entityId} employeeData={employeeData} parkinglotObj={parkinglotObj} editOption={editOption} mapVisibleChangesAlert={handleMapVisibleChanges} empRegistrationId={empRegistrationId} isEmployee={isEmployee} groupSchedules={parkinglotObj?.groupSchedules || []} /></div>
        ) : (
          <div><MapDashboard defaultaddress={defaultaddress} userData={userDetails} entityId={entityId} employeeData={employeeData} mapVisibleChangesAlert={handleMapVisibleChanges} isEmployee={isEmployee} empRegistrationId={empRegistrationId} /></div>
        )
      )}
    </div>
  );
};

// ✅ New View Design — identical to OwnerParkinglotRegistration.jsx style
const ExpandedGroupsView = ({ data }) => {
  const [expandedGroups, setExpandedGroups] = React.useState({});
  const [expandedMain, setExpandedMain] = React.useState(false);

  // Group PSLs by Group Name
  const groupedData = React.useMemo(() => {
    if (!data?.coardinateDetails) return {};
    const groups = {};
    data.coardinateDetails.forEach((coord) => {
      if (coord.title === "PSL - Parking Space Location") {
        const groupName = coord.groupName || "Default";
        if (!groups[groupName]) groups[groupName] = [];
        groups[groupName].push(coord);
      }
    });
    return groups;
  }, [data]);

  const toggleMainExpand = () => {
    setExpandedMain((prev) => !prev);
  };

  const toggleGroupExpand = (group) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [group]: !prev[group],
    }));
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "15px 25px",
        borderRadius: "10px",
        marginTop: "10px",
        border: "1px solid #e0e0e0",
      }}
    >
      {/* === Main Expandable Header === */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          padding: "12px 14px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#f8f8f8",
          fontWeight: "600",
          fontSize: "15px",
          color: "#333",
        }}
        onClick={toggleMainExpand}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {expandedMain ? (
            <ExpandLessIcon style={{ fontSize: "18px", color: "#444" }} />
          ) : (
            <ExpandMoreIcon style={{ fontSize: "18px", color: "#444" }} />
          )}
          Groups under this Parking Lot
        </div>
      </div>

      {/* === Groups List === */}
      {expandedMain && (
        <div style={{ marginTop: "10px" }}>
          {Object.entries(groupedData).map(([groupName, psls]) => (
            <div
              key={groupName}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                marginBottom: "10px",
                backgroundColor: "#fafafa",
                overflow: "hidden",
              }}
            >
              {/* Group Header */}
              <div
                onClick={() => toggleGroupExpand(groupName)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  padding: "10px 15px",
                  backgroundColor: "#f9f9f9",
                  borderBottom: expandedGroups[groupName]
                    ? "1px solid #e0e0e0"
                    : "none",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  {expandedGroups[groupName] ? (
                    <ExpandLessIcon style={{ fontSize: "16px", color: "#444" }} />
                  ) : (
                    <ExpandMoreIcon style={{ fontSize: "16px", color: "#444" }} />
                  )}
                  <span style={{ fontWeight: "600", fontSize: "15px" }}>
                    {groupName}
                  </span>
                  <span style={{ color: "#666", fontSize: "13px" }}>
                    ({psls.length})
                  </span>
                </div>
              </div>

              {/* Group PSL Table */}
              {expandedGroups[groupName] && (
                <div style={{ backgroundColor: "#fff", padding: "10px 15px" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      border: "1px solid #e0e0e0",
                      borderRadius: "6px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#f2f2f2",
                          fontWeight: "bold",
                          borderBottom: "2px solid #ddd",
                        }}
                      >
                        <th style={{ padding: "10px", textAlign: "center" }}>
                          PSL Name
                        </th>
                        <th style={{ padding: "10px", textAlign: "center" }}>
                          Street Address
                        </th>
                        <th style={{ padding: "10px", textAlign: "center" }}>
                          Created
                        </th>
                        <th style={{ padding: "10px", textAlign: "center" }}>
                          Last Updated
                        </th>
                        <th style={{ padding: "10px", textAlign: "center" }}>
                          Pricing Plan
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {psls.map((psl, idx) => (
                        <tr
                          key={idx}
                          style={{
                            backgroundColor: idx % 2 === 0 ? "#fff" : "#f9f9f9",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          <td style={{ textAlign: "center", padding: "8px" }}>
                            {psl.pslName || `PSL ${idx + 1}`}
                          </td>
                          <td style={{ textAlign: "center", padding: "8px" }}>
                            {data.parkingLotAddress}
                          </td>
                          <td style={{ textAlign: "center", padding: "8px" }}>
                            {data.createdDate || "-"}
                          </td>
                          <td style={{ textAlign: "center", padding: "8px" }}>
                            {data.lastUpdatedDate || "-"}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              padding: "8px",
                              color: psl.pricingPlanName ? "#007bff" : "#999",
                              fontWeight: "500",
                            }}
                          >
                            {psl.pricingPlanName || "Not Assigned"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


export default ViewPrakingLotInfo;
